import { FC } from 'react';

import { ModalComponent } from 'componets/common';
import { SettingsReferralCard } from 'pages/Account/Settings/SettingsReferralCard';

import { ModalProps } from 'models';

export const AccountReferralModal: FC<ModalProps> = ({ isOpen, onClose }) => {
	return (
		<ModalComponent isOpen={isOpen} onClose={onClose} className="settings">
			<SettingsReferralCard />
		</ModalComponent>
	);
};
